module.exports = __webpack_public_path__ + "img/kuwait.6f9978ee.svg";